module.exports = __webpack_public_path__ + "img/word.73c20498.png";